module.exports = __webpack_public_path__ + "media/images/bank_images/besc-f5e33208168c6635ddd202c17fe181db.png";